module.exports = {"missingPermission":"Je hebt helaas geen toegang tot deze pagina.\n","contactAdministration":"Neem contact op met de persoon in je team die de admin-rechten heeft."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/localization/nl-NL/strings.json
// module id = 1231
// module chunks = 0